import { render, staticRenderFns } from "./joboffer-list-item.vue?vue&type=template&id=2f559477&scoped=true"
import script from "./joboffer-list-item.vue?vue&type=script&lang=js"
export * from "./joboffer-list-item.vue?vue&type=script&lang=js"
import style0 from "./joboffer-list-item.vue?vue&type=style&index=0&id=2f559477&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f559477",
  null
  
)

export default component.exports